import { addDays } from 'date-fns';

import caseInsensitiveCompare from '@/utils/caseInsensitiveCompare';

const MIN_REVIEW_DAYS = 7;
// we do not allow reviews on purchases made before the review feature was released
const reviewReleaseDate = new Date('2018-11-29');

export const shouldDelayReview = (saleStart: Date, isBidderSuspended: boolean): boolean => {
    const allowedReviewDate = addDays(saleStart.setHours(0, 0, 0, 0), MIN_REVIEW_DAYS);
    return new Date() < allowedReviewDate && !isBidderSuspended;
};

export const shouldAllowReview = (
    paidStatus: string,
    reviewed: boolean,
    saleStart: Date,
    isBidderSuspended: boolean
): boolean => {
    return (
        saleStart > reviewReleaseDate &&
        !reviewed &&
        !caseInsensitiveCompare(paidStatus, 'overdue') &&
        !isBidderSuspended
    );
};
